export default (config) => {
    config = {
        ...config,
        languages: {
            english: 'English',
            russian: 'Russian',
            //arabic: 'Arabic'
        }
    }
    return config
}